import { TransferBaseModel } from '../transfer-base.model';

export interface B2BTransfer extends TransferBaseModel {
    id?: string;
    login?: string;
    number: string;
    status: string;
    gateway: string;
    email: string;
    deposit_amount: number;
    bank_card_name: string;
    bank_card_number: string;
    created: Date;
}
